import React from 'react';

import CategoryLink from './CategoryLink';

interface CategoryPanelProps {
  categories: string[];
}

function CategoryPanel({categories}: CategoryPanelProps) {
  return (
    <>
      {categories.map(cat => (
        <li className="nav-item" key={cat}>
          <CategoryLink className="nav-link" category={cat} />
        </li>
      ),
      )}
    </>
  );
}

export default CategoryPanel;
